import gql from "graphql-tag";

export const getTextTranslationsQuery = gql(`
query GetTextTranslations($areaId: String!, $clientIds: [String!], $languageCodes: [String!], $translationKeys: [String!], $publishedAt: Float) {
    getTextTranslations(areaId: $areaId, clientIds: $clientIds, languageCodes: $languageCodes, translationKeys: $translationKeys, publishedAt: $publishedAt) {
        id
        areaId
        clientId
        languageCode
        translationKey
        text
        modifiedAt
    }
}
`);

export const setTextTranslationMutation = gql(`
mutation SetTextTranslation($areaId: String!, $clientId: String!, $languageCode: String!, $translationKey: String!, $text: String!) {
    setTextTranslation(areaId: $areaId, clientId: $clientId, languageCode: $languageCode, translationKey: $translationKey, text: $text) {
        id
        areaId
        clientId
        languageCode
        translationKey
        text
        modifiedAt
    }
}
`);
